/** @jsx jsx */
import { jsx } from '@emotion/react';

import EnterpriseLearningPathsModule from 'bundles/page-config-common/components/enterprise/EnterpriseLearningPathsModule';
import EnterpriseSingleLearningPathModule from 'bundles/page-config-common/components/enterprise/EnterpriseSingleLearningPathModule';
import HomeSection from 'bundles/page-config-common/components/shared/HomeSection';
import { useEnterpriseBadgeCollections } from 'bundles/page-config-common/contexts/enterprise/EnterpriseBadgeCollectionsContext';

const EnterpriseLearningPathsModuleRenderer = () => {
  const { enterpriseBadgesWithCollection } = useEnterpriseBadgeCollections();

  if (enterpriseBadgesWithCollection.length === 0) {
    return null;
  }

  return (
    <HomeSection className="PageConfig_EnterpriseLearningPaths" dataTestId="enterprise-learning-paths">
      {enterpriseBadgesWithCollection.length > 1 ? (
        <EnterpriseLearningPathsModule enterpriseBadgesWithCollection={enterpriseBadgesWithCollection} />
      ) : (
        <EnterpriseSingleLearningPathModule enterpriseBadgeWithCollection={enterpriseBadgesWithCollection[0]} />
      )}
    </HomeSection>
  );
};

export default EnterpriseLearningPathsModuleRenderer;
